
const outcomeTypes = {
	COMMITMENT: "ACTION_ITEM",
	DECISION: "DECISION",
	NOTE: "SUMMARY",
	CONCLUSION: "CONCLUSION",
};

export default Object.freeze( outcomeTypes );

export const isValid = outcomeType => {
	return Object.values( outcomeTypes ).includes( outcomeType );
};



// WEBPACK FOOTER //
// ./src/constants/OutcomeType.js